import { service } from '@/utils/request'

export default {
	// 直播列表
	getLiveList(data) {
		return service({
			url: '/cloud/course/admin/live/pages',
			method: 'post',
			data
		})
	},
    // 导出数据
	exportExcel(data) {
		return service({
			url: '/cloud/course/admin/live/exportLiveExcel',
			method: 'post',
			data,
			responseType: 'blob'
		})
	},
	// 直播数据-分页
	getLiveData(data) {
		return service({
			url: '/cloud/course/admin/live/pages',
			method: 'post',
			data
		})
	},
	// 直播报名人数-分页
	getSignUpPages(params) {
		return service({
			url: '/cloud/course/admin/live/signUpPages',
			method: 'get',
			params
		})
	},
	// 直播报名人数-导出
	exportSignUpExcel(params) {
		return service({
			url: '/cloud/course/admin/live/exportSignUpExcel',
			method: 'get',
			params,
			responseType: 'blob'
		})
	},
	// 直播到课人数-分页
	getUvPages(params) {
		return service({
			url: '/cloud/course/admin/live/uvPages',
			method: 'get',
			params
		})
	},
	// 直播到课人数-导出
	exportUvExcel(params) {
		return service({
			url: '/cloud/course/admin/live/exportUvExcel',
			method: 'get',
			params,
			responseType: 'blob'
		})
	},
	// 直播各阶段的报名人数
	getLiveSignUpNum(params) {
		return service({
			url: '/cloud/course/admin/live/getLiveSignUpNum',
			method: 'get',
			params
		})
	},
	// 刷新统计数据
	refreshStatistics(params) {
		return service({
			url: '/cloud/course/admin/live/refresh',
			method: 'get',
			params
		})
	}
}


// WEBPACK FOOTER //
// ./src/api/contentManage/liveManage.js